<app-matrix-card
  title="{{ 'cards.matrixAnalytics' | translate }}"
  iconUrl="/icons/magnifying_glass.png"
  link="/charts"
  aria-label="{{ 'cards.matrixAnalytics' | translate }}"
>
  <div
    card-header
    class="flex flex-col sm:flex-row w-full items-center justify-center gap-[10px] sm:gap-[16px]"
  >
    <p
      class="text-[18px] sm:text-[24px] tracking-[5.4px] sm:tracking-[7.2px] text-white leading-none whitespace-nowrap"
    >
      <span class="font-normal">MATRIX </span>
      <span class="font-black">ANALYTICS</span>
    </p>

    <div class="flex flex-col gap-[6px] sm:gap-[8px] items-center sm:items-start justify-center">
      <p class="text-[13px] sm:text-[18px] leading-[18px] sm:leading-[22px] text-[#88d3ee]">
        <span class="font-bold">AUDIT:</span> Last 180 Days (12/2/24 - 6/2/25)
      </p>

      <div class="flex items-center gap-[16px] sm:gap-[24px]">
        <div class="flex items-center gap-[6px] sm:gap-[8px]">
          <span class="inline-block size-[12px] sm:size-[18px] rounded-full bg-red-500"></span>
          <span class="text-[12px] sm:text-[14px] leading-[18px] sm:leading-[20px] text-white"
            >Data change</span
          >
        </div>
        <div class="flex items-center gap-[6px] sm:gap-[8px]">
          <span class="inline-block size-[12px] sm:size-[18px] rounded-full bg-violet-500"></span>
          <span class="text-[12px] sm:text-[14px] leading-[18px] sm:leading-[20px] text-white"
            >7 days since review</span
          >
        </div>
      </div>
    </div>
  </div>

  <matrix-generic-table
    [columns]="columns()"
    [data]="data()"
    [totalRecords]="totalRecords()"
    [rows]="rows()"
    [loading]="loading()"
    [scrollHeight]="scrollHeight"
    [lazy]="false"
    [searchEnabled]="false"
    [exportEnabled]="false"
    (queryChange)="onQueryChange($event)"
  />

  <ng-template #trendHeader>
    <p class="text-center text-white leading-none">
      <span class="text-[14px] sm:text-[18px] font-semibold leading-[18px] sm:leading-[22px]"
        >Real Time</span
      >
      <br />
      <span class="text-[11px] sm:text-[14px] font-normal leading-[16px] sm:leading-[20px]"
        >(7 Day Trend)</span
      >
    </p>
  </ng-template>

  <ng-template #trendCell let-row="row">
    <div class="flex items-center justify-center w-full">
      <img
        [src]="trendIcon(row.trend7dDirection)"
        [alt]="'Trend ' + row.trend7dDirection"
        class="block h-5 w-6 object-contain opacity-90"
        loading="lazy"
      />
    </div>
  </ng-template>

  <ng-template #employeeCell let-row="row">
    <span class="text-white underline underline-offset-2">{{ row.employeeName }}</span>
  </ng-template>
</app-matrix-card>

<ng-template #statusHeaderTpl let-col="col">
  <div class="flex items-center gap-1 sm:gap-[7px] whitespace-nowrap">
    <span>{{ col.header }}</span>
    <!-- TODO: The status icon will be displayed later -->
    <!-- <img src="/Status.svg" alt="" class="w-10 h-10 sm:w-[40px] sm:h-[40px] shrink-0" aria-hidden="true" /> -->
  </div>
</ng-template>
